/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {hAreaCodeEnum} from '../../../../../hiya-common/src/reducers/env'

export const subscribe_world_cup_match = createAsyncThunk(
  'worldCup/subscribe_world_cup_match',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/room/subscribe_world_cup_match',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const bind_room_fto = createAsyncThunk(
  'worldCup/bind_room_fto',
  async (params: any, store: any) => {
    const {
      deviceinfo: {h_web_room_id},
    } = store.getState().env
    const resp = await http.post(
      '/live/room/bind_room_fto',
      {
        room_id: h_web_room_id,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const get_world_cup_match_list = createAsyncThunk(
  'worldCup/get_world_cup_match_list',
  async (params: any, store: any) => {
    const {
      deviceinfo: {h_web_room_id},
    } = store.getState().env
    const resp = await http.post(
      '/live/room/get_world_cup_match_list',
      {
        room_id: h_web_room_id,
        offset: 0,
        limit: 1000,
        page_size: 1000,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp?.data?.data?.list || []
  }
)

export const get_world_cup_match_events = createAsyncThunk(
  'worldCup/get_world_cup_match_events',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/room/get_world_cup_match_events',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.events || []
  }
)
export const get_world_cup_match_detail = createAsyncThunk(
  'worldCup/get_world_cup_match_detail',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/room/get_world_cup_match_detail',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    const {match, ...rest} = resp.data.data || {}
    return {...match, ...rest}
  }
)
export const get_world_cup_match_stats = createAsyncThunk(
  'worldCup/get_world_cup_match_stats',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/room/get_world_cup_match_stats',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.stats || {}
  }
)
export const get_world_cup_match_lineup = createAsyncThunk(
  'worldCup/get_world_cup_match_lineup',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/room/get_world_cup_match_lineup',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.lineup || {}
  }
)
export const get_room_role = createAsyncThunk(
  'worldCup/get_room_role',
  async (params: any, store: any) => {
    const {h_web_room_id, h_m} = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/room/get_room_role',
      {
        room_id: h_web_room_id,
        mid: h_m,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    const role = resp?.data?.data?.role || 0
    if (role === 0) {
      return 2
    }
    if (role === 1) {
      return 0
    }
    return 1
  }
)
export const get_room_isPk = createAsyncThunk(
  'worldCup/is_room_in_pk',
  async (params: any, store: any) => {
    const {h_web_room_id, h_m} = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/room/is_room_in_pk',
      {
        room_id: h_web_room_id,
        mid: h_m,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.in_pk
  }
)
export const room_fto_vote = createAsyncThunk(
  'worldCup/room_fto_vote',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/room_fto_vote',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const get_user_world_cup_point = createAsyncThunk(
  'worldCup/get_user_world_cup_point',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/get_user_world_cup_point',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const exchange_goods = createAsyncThunk(
  'worldCup/exchange_goods',
  async (params: any, store: any) => {
    const {h_area_code} = store.getState().env.deviceinfo
    const exg_system_id = [hAreaCodeEnum.ar, hAreaCodeEnum.tp].includes(
      h_area_code
    )
      ? 641
      : 640
    const resp = await http.post(
      '/live/privilege/world_cup_point_exchange_goods',
      {
        ...params,
        exg_system_id: ENV === 'production' ? exg_system_id : 471,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const get_store_goods_list = createAsyncThunk(
  'worldCup/get_store_goods_list',
  async (params: any, store: any) => {
    const {h_area_code} = store.getState().env.deviceinfo
    const exg_system_id = [hAreaCodeEnum.ar, hAreaCodeEnum.tp].includes(
      h_area_code
    )
      ? 641
      : 640
    const resp = await http.post(
      '/live/commonactivity/get_store_goods_list',
      {
        ...params,
        exg_system_id: ENV === 'production' ? exg_system_id : 471,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.list || []
  }
)
export const world_cup_point_raffle = createAsyncThunk(
  'worldCup/world_cup_point_raffle',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/world_cup_point_raffle',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.reward_map || []
  }
)
export const get_raffle_info = createAsyncThunk(
  'worldCup/get_raffle_info',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/misc/get_raffle_info',
      {
        pool_type: 'world_cup_point',
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.rewards || []
  }
)
export const get_gifts_with_ids = createAsyncThunk(
  'worldCup/get_gifts_with_ids',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/gift/get_gifts_with_ids',
      {
        ...params,
        ids: [12991, 12987, 12986, 13036, 13037],
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.list || []
  }
)
export interface InitialStateType {
  cupList: Array<any>
  matchEvents: Array<any>
  matchDetail: any
  matchStats: any
  matchLineUps: any
  base: {
    role: number
    isPk: boolean
  }
  pointInfo: {
    total_point: number
    one_day_expire_point: number
    time_cutdown: number
    use_status: number
  }
  raffleRewards: Array<any>
  exchangeGoodsList: Array<any>
  gifts: Array<any>
}

const initialState: InitialStateType = {
  cupList: [],
  matchEvents: [],
  matchDetail: {},
  matchStats: {},
  matchLineUps: {},
  base: {
    role: 0,
    isPk: false,
  },
  pointInfo: {
    total_point: 0,
    one_day_expire_point: 0,
    time_cutdown: 0,
    use_status: 0,
  },
  raffleRewards: [],
  exchangeGoodsList: [],
  gifts: [],
}

export const WorldCupSlice = createSlice({
  name: 'worldCup',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_world_cup_match_list.fulfilled, (state, action) => {
      Object.assign(state, {cupList: action.payload})
    })
    builder.addCase(get_world_cup_match_events.fulfilled, (state, action) => {
      Object.assign(state, {matchEvents: action.payload})
    })
    builder.addCase(get_world_cup_match_detail.fulfilled, (state, action) => {
      Object.assign(state.matchDetail, action.payload)
    })
    builder.addCase(get_world_cup_match_stats.fulfilled, (state, action) => {
      Object.assign(state.matchStats, action.payload)
    })
    builder.addCase(get_world_cup_match_lineup.fulfilled, (state, action) => {
      Object.assign(state.matchLineUps, action.payload)
    })
    builder.addCase(get_room_isPk.fulfilled, (state, action) => {
      Object.assign(state.base, {isPk: action.payload})
    })
    builder.addCase(get_room_role.fulfilled, (state, action) => {
      Object.assign(state.base, {role: action.payload})
    })
    builder.addCase(get_user_world_cup_point.fulfilled, (state, action) => {
      Object.assign(state.pointInfo, action.payload)
    })
    builder.addCase(get_raffle_info.fulfilled, (state, action) => {
      Object.assign(state.raffleRewards, action.payload)
    })
    builder.addCase(get_store_goods_list.fulfilled, (state, action) => {
      Object.assign(state.exchangeGoodsList, action.payload)
    })
    builder.addCase(get_gifts_with_ids.fulfilled, (state, action) => {
      Object.assign(state.gifts, action.payload)
    })
  },
})
export default WorldCupSlice.reducer
export const WorldCupActions = WorldCupSlice.actions

export const useWorldCupState = () => {
  const data = useSelector((state) => {
    return state.worldCup
  })
  return data
}
